/**
 * Animations RAWNAQ.
 * - Apparition au défilement : chaque section de la page (hors en-tête) et chaque carte produit
 *   remonte en fondu quand elle entre à l'écran ; les cartes d'une même grille apparaissent en cascade.
 * - Parallaxe douce sur les éléments [data-rq-parallax="vitesse"].
 * Désactivé si l'utilisatrice a demandé à réduire les animations.
 */
if (!window.__rqMotion && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  window.__rqMotion = true;
  const root = document.documentElement;
  root.classList.add('rq-motion');

  const SELECTOR = [
    '#MainContent > .shopify-section:not(:first-child)',
    '#MainContent product-card',
    '#MainContent .collection-card',
    '.rq-reas__item',
    '.rq-rv__card',
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('rq-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const watch = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.rqWatched) return;
      el.dataset.rqWatched = 'true';
      el.classList.add('rq-reveal');
      const siblings = el.parentElement ? [...el.parentElement.children] : [];
      const index = Math.min(siblings.indexOf(el), 8);
      if (index > 0 && !el.matches('.shopify-section')) el.style.setProperty('--rq-delay', `${index * 0.08}s`);
      observer.observe(el);
    });
  };

  watch();
  new MutationObserver(() => watch()).observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true,
  });

  /* Parallaxe */
  const items = () => [...document.querySelectorAll('[data-rq-parallax]')];
  let ticking = false;
  const update = () => {
    ticking = false;
    const vh = innerHeight;
    for (const el of items()) {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue;
      const speed = Number(el.dataset.rqParallax) || 0.08;
      const offset = (rect.top + rect.height / 2 - vh / 2) * speed;
      const child = el.firstElementChild;
      if (child) child.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
    }
  };
  addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  update();
}
